export default __webpack_public_path__ + "static/media/mail_grey_icon.03f50c92.svg";